// extracted by mini-css-extract-plugin
module.exports = {"info":"EquipmentModalInfo_info__uKiBq","collapsible":"EquipmentModalInfo_collapsible__tNr7S"};